/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { Dropdown } from "react-bootstrap";
import { DropdownCustomToggler, DropdownMenu4 } from "../../dropdowns";
import { toAbsoluteUrl } from "../../../_helpers";

export function LastErrorsWidget({ className }) {
  return (
    <>
      <div className={`card card-custom ${className}`}>
        {/* Header */}
        <div className="card-header border-0">
          <h3 className="card-title font-weight-bolder text-dark">آخرین خطاهای رخ داده</h3>
        </div>

        {/* Body */}
        <div className="card-body pt-0">
          {/*<div className="d-flex align-items-center mb-9 bg-light-warning rounded p-5">*/}
          {/*  <span className="svg-icon svg-icon-warning mr-5 svg-icon-lg">*/}
          {/*    <SVG*/}
          {/*      src={toAbsoluteUrl("/media/svg/icons/Home/Library.svg")}*/}
          {/*    ></SVG>*/}
          {/*  </span>*/}
          
          {/*  <div className="d-flex flex-column flex-grow-1 mr-2">*/}
          {/*    <a*/}
          {/*      href="#"*/}
          {/*      className="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"*/}
          {/*    >*/}
          {/*      Group lunch celebration*/}
          {/*    </a>*/}
          {/*    <span className="text-muted font-weight-bold">Due in 2 Days</span>*/}
          {/*  </div>*/}
          
          {/*  <span className="font-weight-bolder text-warning py-1 font-size-lg">*/}
          {/*    +28%*/}
          {/*  </span>*/}
          {/*</div>*/}

        </div>
      </div>
    </>
  );
}
